/**
 * Tabela de Natureza Jurídica 2021 (IBGE/CONCLA), indexed by the four digit code.
 *
 * Generated by `node ./scripts/legal-natures.ts`. Do not edit by hand.
 *
 * 92 of the 100 entries are the official codes from the CONCLA 2021 table; the other
 * 8 (2076, 2100, 2208, 3042, 3050, 3093, 3123, 5002) are legacy codes a past revision
 * retired, mapped to the code they correspond to today by `LEGACY_LEGAL_NATURE` and still
 * accepted because they keep appearing in records filed while they were in force. Separately, and
 * unrelated to those legacy codes, the descriptions of the following official codes fix an accent
 * typo of the PDF: 3298.
 *
 * The CONCLA table page sits behind a bot filter and answers HTTP 403 to every non-browser
 * client, so it has to be opened in a browser; the detailed structure PDF next to it is served
 * normally.
 *
 * @see Official: https://concla.ibge.gov.br/estrutura/natjur-estrutura/natureza-juridica-2021
 * @see Official: https://concla.ibge.gov.br/images/concla/documentacao/CONCLA-TNJ2021-EstruturaDetalhada.pdf
 */
export const LEGAL_NATURE: Record<string, string> = {
	"1015": "Órgão Público do Poder Executivo Federal",
	"1023": "Órgão Público do Poder Executivo Estadual ou do Distrito Federal",
	"1031": "Órgão Público do Poder Executivo Municipal",
	"1040": "Órgão Público do Poder Legislativo Federal",
	"1058": "Órgão Público do Poder Legislativo Estadual ou do Distrito Federal",
	"1066": "Órgão Público do Poder Legislativo Municipal",
	"1074": "Órgão Público do Poder Judiciário Federal",
	"1082": "Órgão Público do Poder Judiciário Estadual",
	"1104": "Autarquia Federal",
	"1112": "Autarquia Estadual ou do Distrito Federal",
	"1120": "Autarquia Municipal",
	"1139": "Fundação Pública de Direito Público Federal",
	"1147": "Fundação Pública de Direito Público Estadual ou do Distrito Federal",
	"1155": "Fundação Pública de Direito Público Municipal",
	"1163": "Órgão Público Autônomo Federal",
	"1171": "Órgão Público Autônomo Estadual ou do Distrito Federal",
	"1180": "Órgão Público Autônomo Municipal",
	"1198": "Comissão Polinacional",
	"1210": "Consórcio Público de Direito Público (Associação Pública)",
	"1228": "Consórcio Público de Direito Privado",
	"1236": "Estado ou Distrito Federal",
	"1244": "Município",
	"1252": "Fundação Pública de Direito Privado Federal",
	"1260": "Fundação Pública de Direito Privado Estadual ou do Distrito Federal",
	"1279": "Fundação Pública de Direito Privado Municipal",
	"1287": "Fundo Público da Administração Indireta Federal",
	"1295": "Fundo Público da Administração Indireta Estadual ou do Distrito Federal",
	"1309": "Fundo Público da Administração Indireta Municipal",
	"1317": "Fundo Público da Administração Direta Federal",
	"1325": "Fundo Público da Administração Direta Estadual ou do Distrito Federal",
	"1333": "Fundo Público da Administração Direta Municipal",
	"1341": "União",
	"2011": "Empresa Pública",
	"2038": "Sociedade de Economia Mista",
	"2046": "Sociedade Anônima Aberta",
	"2054": "Sociedade Anônima Fechada",
	"2062": "Sociedade Empresária Limitada",
	"2070": "Sociedade Empresária em Nome Coletivo",
	"2089": "Sociedade Empresária em Comandita Simples",
	"2097": "Sociedade Empresária em Comandita por Ações",
	"2127": "Sociedade em Conta de Participação",
	"2135": "Empresário (Individual)",
	"2143": "Cooperativa",
	"2151": "Consórcio de Sociedades",
	"2160": "Grupo de Sociedades",
	"2178": "Estabelecimento, no Brasil, de Sociedade Estrangeira",
	"2194": "Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira",
	"2216": "Empresa Domiciliada no Exterior",
	"2224": "Clube/Fundo de Investimento",
	"2232": "Sociedade Simples Pura",
	"2240": "Sociedade Simples Limitada",
	"2259": "Sociedade Simples em Nome Coletivo",
	"2267": "Sociedade Simples em Comandita Simples",
	"2275": "Empresa Binacional",
	"2283": "Consórcio de Empregadores",
	"2291": "Consórcio Simples",
	"2305": "Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)",
	"2313": "Empresa Individual de Responsabilidade Limitada (de Natureza Simples)",
	"2321": "Sociedade Unipessoal de Advogados",
	"2330": "Cooperativas de Consumo",
	"2348": "Empresa Simples de Inovação - Inova Simples",
	"2356": "Investidor Não Residente",
	"3034": "Serviço Notarial e Registral (Cartório)",
	"3069": "Fundação Privada",
	"3077": "Serviço Social Autônomo",
	"3085": "Condomínio Edilício",
	"3107": "Comissão de Conciliação Prévia",
	"3115": "Entidade de Mediação e Arbitragem",
	"3131": "Entidade Sindical",
	"3204": "Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras",
	"3212": "Fundação ou Associação Domiciliada no Exterior",
	"3220": "Organização Religiosa",
	"3239": "Comunidade Indígena",
	"3247": "Fundo Privado",
	"3255": "Órgão de Direção Nacional de Partido Político",
	"3263": "Órgão de Direção Regional de Partido Político",
	"3271": "Órgão de Direção Local de Partido Político",
	"3280": "Comitê Financeiro de Partido Político",
	"3298": "Frente Plebiscitária ou Referendária",
	"3301": "Organização Social (OS)",
	"3310": "Demais Condomínios",
	"3328": "Plano de Benefícios de Previdência Complementar Fechada",
	"3999": "Associação Privada",
	"4014": "Empresa Individual Imobiliária",
	"4022": "Segurado Especial",
	"4081": "Contribuinte individual",
	"4090": "Candidato a Cargo Político Eletivo",
	"4111": "Leiloeiro",
	"4120": "Produtor Rural (Pessoa Física)",
	"5010": "Organização Internacional",
	"5029": "Representação Diplomática Estrangeira",
	"5037": "Outras Instituições Extraterritoriais",

	"2076": "Sociedade Empresária em Nome Coletivo",
	"2100": "Sociedade Mercantil de Capital e Indústria (extinta pelo NCC/2002)",
	"2208": "Entidade Binacional Itaipu",
	"3042": "Organização Social",
	"3050": "Organização da Sociedade Civil de Interesse Público (Oscip)",
	"3093": "Unidade Executora (Programa Dinheiro Direto na Escola)",
	"3123": "Partido Político",
	"5002": "Organização Internacional e Outras Instituições Extraterritoriais",
};

/**
 * The code each legacy legal nature code corresponds to today, or `null` when the revision that
 * retired it published no successor, indexed by the legacy code.
 *
 * Generated by `node ./scripts/legal-natures.ts`. Do not edit by hand.
 *
 * The mapping is the one the CONCLA correspondence spreadsheets publish. 2076 is the 2003 spelling
 * of the code the 2003.1 revision renumbered to 2070, under the same denomination; 2208 (Empresa
 * Binacional Itaipu) became 2275 (Empresa Binacional); 3042 (Organização Social) became 3069
 * (Fundação Privada), and the 2014 revision later created 3301 (Organização Social (OS)), where an
 * entity qualified as one is classified today; 3093 became 3999; and 5002 was opened into 5010,
 * 5029 and 5037, with 5010 published as its correspondence. The other three have none: 2100 is
 * marked "categoria extinta", 3050 (Oscip) has an empty correspondence because an Oscip is
 * classified by the form it takes (3999 or 3069), and 3123 (Partido Político), still in the 2009
 * table, was dropped by the 2014 one, which split it into 3255, 3263 and 3271 without publishing a
 * correspondence.
 *
 * The CONCLA pages sit behind a bot filter and answer HTTP 403 to every non-browser client, so
 * they have to be opened in a browser; the spreadsheets next to them are served normally.
 *
 * @see Official: https://concla.ibge.gov.br/classificacoes/correspondencias/natureza-juridica.html
 * @see Official: https://concla.ibge.gov.br/images/concla/documentacao/correspTNJ2003(1)-2009.xls
 * @see Official: https://concla.ibge.gov.br/images/concla/documentacao/correspTNJ1995-2002-2003.xls
 */
export const LEGACY_LEGAL_NATURE: Record<string, string | null> = {
	"2076": "2070",
	"2100": null,
	"2208": "2275",
	"3042": "3069",
	"3050": null,
	"3093": "3999",
	"3123": null,
	"5002": "5010",
};
